import {
  Page,
  Document,
  PDFViewer,
  Image,
  View,
  Text,
  StyleSheet,
} from "@react-pdf/renderer";
import { Request } from "../../hooks/Request";
import { validateArray } from "../../utils/validate";
import dayjs from "dayjs";

const s = StyleSheet.create({
  page: {
    padding: "50px 65px 0 60px",
    fontFamily: "Helvetica",
    fontSize: 10,
  },
  bold: { fontFamily: "Helvetica-Bold" },
  italic: { fontFamily: "Helvetica-Oblique" },
  row: { display: "flex", flexDirection: "row", gap: 0 },
  col: { display: "flex", flexDirection: "column", gap: 0 },
  header: {
    position: "absolute",
    top: -1.2,
    right: "20px",
    zIndex: -10,
  },
  styleFormat: {
    position: "absolute",
    top: "0",
    left: "0",
    zIndex: -10,
    width: "612px",
    height: "792px",
  },
  cell: { paddingHorizontal: 3, paddingVertical: 2 },
  bLeft: { borderLeftWidth: 1 },
  bRight: { borderRightWidth: 1 },
  bBottom: { borderBottomWidth: 1 },
  bTop: { borderTopWidth: 1 },
  bAll: { borderWidth: 1 },
  txtCenter: { textAlign: "center" },
  border: { borderWidth: 1 },
  w10: { width: "10%" },
  w20: { width: "20%" },
  w30: { width: "30%" },
  w40: { width: "40%" },
  w45: { width: "45%" },
  w50: { width: "50%" },
  w55: { width: "55%" },
  w60: { width: "60%" },
  w70: { width: "70%" },
  w80: { width: "80%" },
  w90: { width: "90%" },
  wfull: { width: "100%" },
});

const listFields = [
  "modalidadDeDespacho",
  "descripciónDeLaMercancía",
  "partidaArancelaria",
  "tributosAduaneros",
  "gastosNoFacturados",
  "gastosFacturados",
  "honorariosProfesionales",
  "pagos",

  //datos generales
  "nroExamenPrevio",
  "a1TipoExPrev", //N° Examen previo
  "a2NroParteDeRecepcionExPrev", //N° de parte de recepcióno
  "a5MotivoDeLaSolicitudExPrev", //Motivo de la solicitud
  "d3CantidadDeBultosExPrev", // Cantidad de bultos
  "c4PesoRecibidoExPrev", //Peso recibido
  "documentosSeccionL", //subdata => buscar "FACTURA COMERCIAL"
  "a3FormaDeEnvioExPrev",
  "a4DocumentoAsociadoExPrev",
  "a6FechaProgramadaExPrev",
  "a7AlmacenExPrev",
  "a8",

  //campos
  "observacionesIdentificadasPorItem",
  "observacionesDeLaHojaDeTrabajo",
];
export const GenerateWorkSheetPDF = (props) => {
  const { procedure } = props;
  const { data, loading } = Request({
    urlApi: `/Procedure/${
      procedure.id || procedure.procedureId
    }/dataValues?${listFields.map((field) => `fieldnames=${field}`).join("&")}`,
  });

  if (!loading) {
    return null;
  }

  const MyDoc = () => {
    const facturaData =
      (validateArray(data.documentosSeccionLSubDatas) &&
        data?.documentosSeccionLSubDatas?.find(
          (item) => item.label?.toUpperCase() === "FACTURA COMERCIAL"
        )?.description2) ||
      "";
    const factura = facturaData.toString().split(" ")[0] ?? "";

    const DynamicTable = ({ columns, data }) => {
      return (
        <View style={[]}>
          {/* Header */}
          <View style={[s.row]}>
            {columns.map((col, index) => (
              <View
                key={index}
                style={[
                  s.txtCenter,
                  s.bBottom,
                  s.bRight,
                  {
                    width: col.width ? col.width : "auto",
                    backgroundColor: "#efefef",
                  },
                ]}
              >
                <Text style={s.cell}>{col.label}</Text>
              </View>
            ))}
          </View>

          {/* Body */}
          {data.map((row, rowIndex) => (
            <View key={rowIndex} style={s.row}>
              {columns.map((col, colIndex) => (
                <View
                  key={colIndex}
                  style={[
                    s.bRight,
                    s.bBottom,
                    {
                      width: col.width ? col.width : "auto",
                      textAlign: col.center ? "center" : "left",
                    },
                  ]}
                >
                  <Text style={s.cell}>{row[col.key] ?? "-"}</Text>
                </View>
              ))}
            </View>
          ))}
        </View>
      );
    };

    const CellText = ({ children, style = [] }) => {
      const combinedStyle = Array.isArray(style) ? style : [];

      return <Text style={[s.cell, ...combinedStyle]}>{children}</Text>;
    };

    return (
      <Document>
        <Page size="LETTER" orientation="landscape" style={s.page}>
          {/* Cabecera */}
          <View style={[s.row, s.bAll]}>
            <View
              style={[
                s.w30,
                s.row,
                s.bRight,
                { justifyContent: "center", alignItems: "center" },
              ]}
            >
              <Image
                style={{ height: "30px" }}
                source={"/images/logo-aduana.png"}
              />
            </View>
            <View
              style={[
                s.w40,
                s.bold,
                s.txtCenter,
                s.bRight,
                { fontSize: 14, justifyContent: "flex-end" },
              ]}
            >
              <Text>REGISTRO</Text>
              <Text>HOJA DE TRABAJO</Text>
            </View>
            <View style={[s.w30, s.txtCenter]}>
              <View style={[s.bBottom]}>
                <CellText>CODIGO</CellText>
              </View>
              <View style={[s.bBottom]}>
                <CellText>R-506</CellText>
              </View>
              <View style={[s.row]}>
                <View style={[s.w30, s.bRight]}>
                  <CellText style={[s.bBottom]}>Version</CellText>
                  <CellText>3</CellText>
                </View>
                <View style={[s.w70]}>
                  <CellText style={[s.bBottom]}>Nº de pagina</CellText>
                  <CellText>1 DE 1</CellText>
                </View>
              </View>
            </View>
          </View>
          {/* Paso 1 */}
          <View style={[s.bBottom, s.bLeft, s.bRight]}>
            <View style={s.bBottom}>
              <CellText
                style={[
                  s.bold,
                  { backgroundColor: "#7f7f7f", color: "#fafafa" },
                ]}
              >
                PASO N° 1
              </CellText>
            </View>
            <View style={[s.row, s.txtCenter, s.bBottom]}>
              <View style={[s.w30, s.bRight]}>
                <CellText
                  style={[s.bold, s.bBottom, { backgroundColor: "#cfcfcf" }]}
                >
                  N° Examen Previo
                </CellText>
                <CellText>{data.nroExamenPrevio ?? " "}</CellText>
              </View>
              <View style={[s.w30, s.bRight]}>
                <CellText
                  style={[s.bold, s.bBottom, { backgroundColor: "#cfcfcf" }]}
                >
                  N° de parte de recepcióno
                </CellText>
                <CellText>{data.a2NroParteDeRecepcionExPrev ?? " "}</CellText>
              </View>
              <View style={[s.w40]}>
                <CellText
                  style={[s.bold, s.bBottom, { backgroundColor: "#cfcfcf" }]}
                >
                  Motivo de la solicitud
                </CellText>
                <CellText>{data.a5MotivoDeLaSolicitudExPrev ?? " "}</CellText>
              </View>
            </View>

            <View style={[s.row, s.txtCenter, s.bBottom]}>
              <View style={[s.w50, s.bRight]}>
                <CellText
                  style={[s.bold, s.bBottom, { backgroundColor: "#cfcfcf" }]}
                >
                  Cantidad de Bultos
                </CellText>
                <CellText>{data.d3CantidadDeBultosExPrev ?? " "}</CellText>
              </View>
              <View style={[s.w50]}>
                <CellText
                  style={[s.bold, s.bBottom, { backgroundColor: "#cfcfcf" }]}
                >
                  Peso Bruto en Kg.
                </CellText>
                <CellText>{data.c4PesoRecibidoExPrev ?? " "}</CellText>
              </View>
            </View>

            <View style={s.txtCenter}>
              <View style={[s.row, s.bBottom]}>
                <CellText
                  style={[
                    s.w40,
                    s.bold,
                    s.bRight,
                    { backgroundColor: "#cfcfcf" },
                  ]}
                >
                  Importador
                </CellText>
                <CellText style={[s.w60]}>
                  {data.company.razonSocial ?? " "}
                </CellText>
              </View>
              <View style={[s.row]}>
                <CellText
                  style={[
                    s.w40,
                    s.bold,
                    s.bRight,
                    { backgroundColor: "#cfcfcf" },
                  ]}
                >
                  Declarante
                </CellText>
                <CellText style={[s.w60]}>DELIVERYDAY S.R.L.</CellText>
              </View>
            </View>
          </View>
          {/* Paso 2 */}
          <View style={[s.bBottom, s.bLeft, s.bRight]}>
            <View
              style={[
                s.bBottom,
                { backgroundColor: "#7f7f7f", color: "#fafafa" },
              ]}
            >
              <CellText style={[s.bold]}>PASO N° 2</CellText>
            </View>
            <View style={s.bBottom}>
              <CellText
                style={[s.bold, s.txtCenter, { backgroundColor: "#afafaf" }]}
              >
                RESULTADO DE LA VERIFICACIÓN POR EXAMEN PREVIO{" "}
              </CellText>
            </View>
            <View style={[s.row, s.bBottom]}>
              <CellText
                style={[
                  s.bold,
                  s.w50,
                  s.bRight,
                  s.txtCenter,
                  { backgroundColor: "#cfcfcf" },
                ]}
              >
                Factura N°:
              </CellText>
              <CellText style={[s.w50]}>{factura ?? " "}</CellText>
            </View>
            <View style={[s.row, s.bBottom]}>
              <CellText
                style={[
                  s.bold,
                  s.w40,
                  s.bRight,
                  { backgroundColor: "#cfcfcf" },
                ]}
              >
                Cantidad de bultos verificados{" "}
              </CellText>
              <CellText style={[s.w60]}>
                {data.d3CantidadDeBultosExPrev ?? " "}
              </CellText>
            </View>
            <View>
              <CellText style={[s.bold, { backgroundColor: "#cfcfcf" }]}>
                Identificación de la mercancía por ítem verificado
              </CellText>
            </View>
          </View>
          {/* Items */}
          <View style={[s.wfull, s.bLeft]}>
            <DynamicTable
              columns={[
                { label: "Item", key: "id", width: "15%", center: true },
                {
                  label: "Observaciones identificadas",
                  key: "description",
                  width: "85%",
                },
              ]}
              data={data.observacionesIdentificadasPorItemSubDatas ?? []}
            />
          </View>
          {/* Observaciones */}
          <View style={[s.wfull, s.bBottom, s.bLeft, s.bRight]}>
            <View style={[s.bBottom]}>
              <CellText style={[s.bBottom]}>
                Otras observaciones como resultado del examen previo:
              </CellText>
              <CellText>{data.observacionesDeLaHojaDeTrabajo ?? " "}</CellText>
            </View>
            <View
              style={[
                s.row,
                s.bBottom,
                { alignItems: "flex-end", height: "3cm" },
              ]}
            >
              <CellText>Firma y nombre de los participantes</CellText>
            </View>
            <View style={[s.italic, s.bBottom, { fontSize: 8 }]}>
              <CellText>RECORDATORIO IMPORTANTE:</CellText>
              <CellText>
                El Parágrafo III del Art. 100 señala: “En caso de encontrarse
                diferencias entre las mercancías objeto de examen previo y los
                documentos aduaneros respectivos, sobre la naturaleza, origen,
                estado, cantidad y calidad que afecten al valor de la mercancía,
                el declarante deberá presentar la declaración de mercancías,
                haciendo constar dichas diferencias para el correspondiente pago
                de tributos aduaneros. Si las diferencias incrementan la base
                imponible, la declaración de mercancías deberá incluir tales
                diferencias para el pago de tributos aduaneros. Por el
                contrario, si las diferencias originan un menor valor, los
                tributos aduaneros serán liquidados sobre la base imponible que
                se establezca a partir del examen previo de las mercancías.”
              </CellText>
            </View>
            <CellText style={{ height: "1cm" }}>
              FECHA: {dayjs().format("DD/MM/YYYY")}
            </CellText>
          </View>
        </Page>
      </Document>
    );
  };

  return (
    <div>
      <PDFViewer
        style={{
          width: 900,
          height: window.innerHeight - 100,
        }}
      >
        <MyDoc />
      </PDFViewer>
    </div>
  );
};
